import { createContext } from "react";

const ProductionViewContext = createContext({});

export default ProductionViewContext;
